import React, { useEffect, useRef, useState } from "react";
import { BlinkBlur } from "react-loading-indicators";
import { categoriesList } from "../constant/categories";

const Categories = ({
	categories,
	selectedCategory,
	setSelectedCategory,
	selectedSubCategory,
	setSelectedSubCategory,
}) => {
	const [openDropdown, setOpenDropdown] = useState(null);

	const [popupPosition, setPopupPosition] = useState({
		top: 0,
		left: 0,
	});
	const popupRef = useRef(null);
	const categoryRef = useRef(null);

	useEffect(() => {
		const handleOutsideClick = (event) => {
			if (
				popupRef.current &&
				!popupRef.current.contains(event.target) &&
				categoryRef.current &&
				!categoryRef.current.contains(event.target)
			) {
				setOpenDropdown(null);
			}
		};

		document.addEventListener("mousedown", handleOutsideClick);

		document.addEventListener("touchstart", handleOutsideClick);

		return () => {
			document.removeEventListener("mousedown", handleOutsideClick);

			document.removeEventListener("touchstart", handleOutsideClick);
		};
	}, []);

	const handleCategoryClick = (category, e) => {
		const rect = e.currentTarget.getBoundingClientRect();
		const popupWidth = 190;
		const screenWidth = window.innerWidth;
		let left = rect.left;

		/* ======================================================
	   PREVENT RIGHT OVERFLOW
	====================================================== */
		if (left + popupWidth > screenWidth - 16) {
			left = screenWidth - popupWidth - 16;
		}

		/* ======================================================
	   PREVENT LEFT OVERFLOW
	====================================================== */
		if (left < 10) {
			left = 10;
		}
		setPopupPosition({
			top: rect.bottom + 8,
			left,
		});

		/* ======================================================
	   TOGGLE
	====================================================== */

		if (selectedCategory === category.category) {
			setOpenDropdown((prev) =>
				prev === category.category ? null : category.category,
			);

			return;
		}

		setSelectedCategory(category.category);

		setSelectedSubCategory("all");

		setOpenDropdown(category.category);
	};

	const getCategoryIcon = (categoryName) => {
		const category = categoriesList.find(
			(item) => item.name.toLowerCase() === categoryName?.toLowerCase(),
		);

		return category?.icon || "fa-tag";
	};

	return (
		<div className="px-3">
			<h5 className="py-3 text-left">Categories</h5>
			{/* {!categories.length && (
				<div className="px-3 mt-5 nearBuSection">
					<BlinkBlur
						color="#494949"
						size="medium"
						text="Loading..."
						textColor="#ffffff"
					/>
				</div>
			)} */}
			<div className="scroll-row mt-2">
				{/* ================= ALL ================= */}

				<div
					ref={categoryRef}
					className={`category-card ${
						selectedCategory === "all" ? "active" : ""
					}`}
					onClick={() => {
						setSelectedCategory("all");
						setSelectedSubCategory("all");
					}}
				>
					<i className="fas fa-border-all pr-2"></i>
					<span>All</span>
				</div>

				{/* ================= DYNAMIC ================= */}

				{categories.map((cat) => (
					<div key={cat.category} className="category-wrapper">
						<div
							className={`category-card ${
								selectedCategory === cat.category
									? "active"
									: ""
							}`}
							onClick={(e) => handleCategoryClick(cat, e)}
						>
							<i
								className={`fa-solid ${getCategoryIcon(
									cat.category,
								)} pr-2`}
							></i>

							<span>
								{cat.category?.charAt(0).toUpperCase() +
									cat.category?.slice(1)}
							</span>
						</div>

						{/* ================= SUB CATEGORY ================= */}

						{openDropdown === cat.category &&
							cat.subCategories?.length > 0 && (
								<div
									ref={popupRef}
									className="subcategory-popup"
									style={{
										top: `${popupPosition.top}px`,
										left: `${popupPosition.left}px`,
									}}
								>
									<div
										className={`subcategory-item ${
											selectedSubCategory === "all"
												? "active-sub"
												: ""
										}`}
										onClick={() =>
											setSelectedSubCategory("all")
										}
									>
										All
									</div>

									{cat.subCategories.map((sub) => (
										<div
											key={sub}
											className={`subcategory-item ${
												selectedSubCategory === sub
													? "active-sub"
													: ""
											}`}
											onClick={() =>
												setSelectedSubCategory(sub)
											}
										>
											{sub}
										</div>
									))}
								</div>
							)}
					</div>
				))}
			</div>
		</div>
	);
};

export default Categories;
